import React from 'react';
import { Boton } from '../../funciones/FuncionesFormacion.js';
import * as Imagenes from '../Iconos.js';
import styles from './Boton.module.css';

const BotonUpDown = (props) => {
  const boton = props.boton;
  const disabled = Boolean(props.disabled);
  const height = props.height;
  const width = props.width;
  const estiloImagen = props.estiloImagen;
  const idObjeto = props.id;
  const presionado = Boolean(props.presionado);
  const tooltip = props.tooltip;

  let imagen = '';
  let textoAlt = '';
  switch (boton) {
    case Boton.GOL: {
      imagen = disabled ? Imagenes.golDisabled : Imagenes.gol;
      textoAlt = 'Gol';
      break;
    }
    case Boton.AMARILLA: {
      imagen = disabled ? Imagenes.tarjetaAmarillaDisabled : Imagenes.tarjetaAmarilla;
      textoAlt = 'Amonestado';
      break;
    }
    case Boton.ROJA: {
      imagen = disabled ? Imagenes.tarjetaRojaDisabled : Imagenes.tarjetaRoja;
      textoAlt = 'Expulsado';
      break;
    }
    case Boton.ENTRA: {
      imagen = disabled ? Imagenes.cambioEntraDisabled : Imagenes.cambioEntra;
      textoAlt = 'Ingresa';
      break;
    }
    case Boton.SALE: {
      imagen = disabled ? Imagenes.cambioSaleDisabled : Imagenes.cambioSale;
      textoAlt = 'Sale';
      break;
    }
    default:
  }

  const onClick = () => {
    props.onClick(boton);
  };

  return (
    <button
      className={`${presionado ? styles.botonAbajo : styles.botonArriba}`}
      name={textoAlt}
      id={idObjeto}
      key={idObjeto}
      disabled={disabled}
      onClick={onClick}
    >
      <img
        className={estiloImagen}
        src={imagen}
        name={textoAlt + '_img'}
        id={idObjeto}
        key={idObjeto}
        width={width}
        height={height}
        alt={textoAlt}
      />
      {presionado && tooltip !== null && tooltip !== '' && <span>{tooltip}</span>}
    </button>
  );
};

export default BotonUpDown;
